var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-layout",class:[
    _vm.$route.meta.showTabBar ? 'show-tab-bar' : ''
  ]},[_c('div',{staticClass:"main-content-container"},[_c('router-view')],1),_c('home-tab-bar',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.meta.showTabBar),expression:"$route.meta.showTabBar"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }